import axios from 'axios';

import restaurant from './mock-data/restaurant.json';
import config from '../config';
import {SentryHelper} from '../helpers/sentry.helper';

class RestaurantApi {
  static getRestaurant(restaurantCode) {
    if (config.mockApi) {
      return new Promise(resolve => {
        const meta = {
          meta: restaurant.meta
        };
        return resolve(Object.assign({}, meta));
      });
    }

    return axios
      .get(`${config.apiUrl}/restaurant/${restaurantCode}`)
      .then(res => {
        this.menu = res.data.menu;
        return res.data;
      })
      .catch(error => {
        SentryHelper.logException(error);
        throw error;
      });
  }

  static getMealByUuid(mealUuid) {
    return this.menu && this.menu.meals[mealUuid];
  }
}

export default RestaurantApi;



// WEBPACK FOOTER //
// ./api/restaurant.api.js